import React, { useState } from "react";
import { AiOutlineCaretDown, AiOutlineCaretUp } from "react-icons/ai";
import styles from "./Dropdown.module.css";

const Dropdown = ({ dropdownItems, setSelectedDuration }) => {
  const [active, setActive] = useState(0);
  const [dropdown, setDropDown] = useState(false);
  const handleDropDown = () => {
    if (dropdown) {
      setDropDown(false);
    } else {
      setDropDown(true);
    }
  };
  return (
    <div className={styles.dropdown}>
      <p className={styles.tab} onClick={handleDropDown}>
        {dropdownItems[active]}
        {dropdown ? (
          <AiOutlineCaretUp className={styles.arrow} />
        ) : (
          <AiOutlineCaretDown className={styles.arrow} />
        )}
      </p>
      {dropdown && (
        <div className={styles.dropdownItems}>
          {dropdownItems.map((el, i) => (
            <p
              key={i}
              onClick={() => {
                let down = el.split(" ")[0];
                setDropDown(false);
                setSelectedDuration(down);
                setActive(i);
              }}
              className={styles.item}
            >
              {el}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
